import { SucursalRutas, GetResponseBody, GetHeaderRequest } from './RutasConfig';

export const Obtener_Sucursales_CallCenter_Request = async (pToken, EmpresaId, CallCenterId) => {
    const data = { EmpresaId, CallCenterId };
    const result = await fetch(SucursalRutas.Obtener_Sucursales_CallCenter, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Obtener_Sucursales_Monitoreo_Request = async (pToken, EmpresaId, CallCenterId, Estado, FechaActivaIni, FechaActivaFin, EstadoExpress) => {
    const data = { EmpresaId, CallCenterId, Estado, FechaActivaIni, FechaActivaFin, EstadoExpress };
    const result = await fetch(SucursalRutas.Obtener_Sucursales_Monitoreo, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};